/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DevourLootboxNftRewardBatchItem } from './DevourLootboxNftRewardBatchItem';
import {
    DevourLootboxNftRewardBatchItemFromJSON,
    DevourLootboxNftRewardBatchItemFromJSONTyped,
    DevourLootboxNftRewardBatchItemToJSON,
    DevourLootboxNftRewardBatchItemToJSONTyped,
} from './DevourLootboxNftRewardBatchItem';

/**
 * 
 * @export
 * @interface CreateDevourLootboxNftRewardsBatchResponse
 */
export interface CreateDevourLootboxNftRewardsBatchResponse {
    /**
     * 
     * @type {Array<DevourLootboxNftRewardBatchItem>}
     * @memberof CreateDevourLootboxNftRewardsBatchResponse
     */
    rewards: Array<DevourLootboxNftRewardBatchItem>;
}

/**
 * Check if a given object implements the CreateDevourLootboxNftRewardsBatchResponse interface.
 */
export function instanceOfCreateDevourLootboxNftRewardsBatchResponse(value: object): value is CreateDevourLootboxNftRewardsBatchResponse {
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    return true;
}

export function CreateDevourLootboxNftRewardsBatchResponseFromJSON(json: any): CreateDevourLootboxNftRewardsBatchResponse {
    return CreateDevourLootboxNftRewardsBatchResponseFromJSONTyped(json, false);
}

export function CreateDevourLootboxNftRewardsBatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDevourLootboxNftRewardsBatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rewards': ((json['rewards'] as Array<any>).map(DevourLootboxNftRewardBatchItemFromJSON)),
    };
}

export function CreateDevourLootboxNftRewardsBatchResponseToJSON(json: any): CreateDevourLootboxNftRewardsBatchResponse {
    return CreateDevourLootboxNftRewardsBatchResponseToJSONTyped(json, false);
}

export function CreateDevourLootboxNftRewardsBatchResponseToJSONTyped(value?: CreateDevourLootboxNftRewardsBatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rewards': ((value['rewards'] as Array<any>).map(DevourLootboxNftRewardBatchItemToJSON)),
    };
}

